import React from 'react';
import PropTypes from 'prop-types';
import { MessageCircle } from 'lucide-react';

/**
 * QueryAssistant Component
 * - Displays AI responses to user queries
 * - Shows question and answer with formatted content
 * - Includes close button to dismiss the response
 */
const QueryAssistant = ({ infoResponse, onClose }) => {
  if (!infoResponse) return null;

  return (
    <div className="ai-info-response-container">
      <div className="ai-info-response">
        <div className="ai-info-response-header">
          <div className="ai-info-title">
            <MessageCircle size={18} />
            <h5>Respuesta</h5>
          </div>
          <button
            className="ai-info-close"
            onClick={onClose}
            title="Cerrar respuesta"
          >
            &times;
          </button>
        </div>
        <div className="ai-info-response-content">
          <div className="ai-info-question">
            <strong>Pregunta:</strong> {infoResponse.question}
          </div>
          <div className="ai-info-answer">{infoResponse.answer}</div>
        </div>
      </div>
    </div>
  );
};

export default QueryAssistant;
